export const participationStats = [
  { value: '7', label: 'Documented fair appearances', icon: 'ri-calendar-check-line' },
  { value: '3', label: 'Countries on record', icon: 'ri-global-line' },
  { value: '40+', label: 'Dated event photographs', icon: 'ri-camera-line' },
  { value: '2022', label: 'Documented since', icon: 'ri-history-line' },
];

export const verificationPrinciples = [
  {
    title: 'Organiser confirmation',
    description:
      'A booth exists on a floor plan before it exists in a photograph. Every entry here corresponds to a booking we can point to in the fair’s own records — hall, stand, and year.',
    icon: 'ri-file-list-3-line',
  },
  {
    title: 'Stand signage, photographed',
    description:
      'Where a stand number is printed below, there is a photograph of the sign carrying it. Not a mock-up, not a graphic — the printed board that stood at the corner of the aisle.',
    icon: 'ri-camera-lens-line',
  },
  {
    title: 'Dated, unedited photography',
    description:
      'The images below were taken on the floor during the fair dates shown. They are published as shot, including the parts of the booth that were still being set up.',
    icon: 'ri-image-2-line',
  },
];

export const participationRecords = [
  {
    id: 'frankfurt-2026',
    startDate: '2026-10-07',
    endDate: '2026-10-11',
    fair: 'Frankfurt Book Fair',
    edition: '2026',
    dates: 'October 7–11, 2026',
    venue: 'Messe Frankfurt',
    city: 'Frankfurt, Germany',
    stand: 'Halle 3.1 / A104',
    standNote: 'Printed on the stand banner and visible in the photographs below.',
    summary:
      'Five days on a corner stand in Halle 3.1, papered with more than two dozen title posters — each with its own ISBN and scan code. The desk stayed occupied from the first morning to the last afternoon.',
    documentation: [
      'Stand sign and banner photographed at A104',
      '10 dated photographs published in the event report',
      'Poster wall listing every title shown, with ISBNs',
    ],
    photos: [
      'https://storage.helloreaddy.io/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/04aa1d51-cd8a-4039-a544-58be26325257_compressed_IMG_2647.webp',
      'https://storage.helloreaddy.io/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/476b629e-94fc-477d-a9b9-d8c911c4c7ae_compressed_IMG_2643.webp',
      'https://storage.helloreaddy.io/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/d9f8e4fa-900a-41e9-9c04-64735718778e_compressed_IMG_2658.webp',
    ],
    reportLink: '/events/frankfurt-book-fair-2026',
  },
  {
    id: 'london-2026',
    startDate: '2026-03-11',
    endDate: '2026-03-13',
    fair: 'London Book Fair',
    edition: '2026',
    dates: 'March 11–13, 2026',
    venue: 'Olympia London',
    city: 'London, United Kingdom',
    stand: null,
    standNote:
      'The stand number for this edition is held in our event file rather than reprinted here. Ask us and we will send the organiser confirmation.',
    summary:
      'Our largest London showing at the time — more than fifty titles across three days, with rights meetings running through the morning and author signings in the afternoon.',
    documentation: [
      '25 photographs from the three fair days',
      'Title list shown at the stand, with formats and prices',
      'Organiser booking confirmation available on request',
    ],
    photos: [
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/337ef5ce-fb1f-467f-b555-85a030086522_London22.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/50cf0f69-7779-4346-84a4-537397dfd40c_London1.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/50376637-090e-4406-8c4b-94c76b8a9d90_London6.jpg',
    ],
    reportLink: '/events',
  },
  {
    id: 'la-times-2026',
    startDate: '2026-04-25',
    endDate: '2026-04-26',
    fair: 'Los Angeles Times Festival of Books',
    edition: '2026',
    dates: 'April 25–26, 2026',
    venue: 'USC Campus',
    city: 'Los Angeles, California',
    stand: null,
    standNote:
      'Festival stands are assigned by the organiser on the week of the event. Our confirmation is on file and can be shared on request.',
    summary:
      'Two days under the California sun at the largest literary festival in the United States, with author signings running almost continuously across both afternoons.',
    documentation: [
      'Booth and signing photographs from both days',
      'Author signing schedule shown at the table',
      'Festival exhibitor listing available on request',
    ],
    photos: [
      'https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/LA-timesbookfair-1280x451-1.jpg',
      'https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/428073306_370741485708407_7399083452050583251_n.jpg',
      'https://mlhdhysslvu0.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://leavittpeakpress.com/wp-content/uploads/2025/02/394693401_304887745627115_5598198918288230239_n.jpg',
    ],
    reportLink: '/events',
  },
  {
    id: 'miami-2025',
    startDate: '2025-11-16',
    endDate: '2025-11-23',
    fair: 'Miami Book Fair',
    edition: '2025',
    dates: 'November 16–23, 2025',
    venue: 'Miami Dade College, Downtown Campus',
    city: 'Miami, Florida',
    stand: null,
    standNote:
      'Stand details from this edition sit in our event file. We would rather point you to the photographs than print a number from memory.',
    summary:
      'Seven days in Downtown Miami with bilingual readers, aspiring writers, and rights scouts working through a catalogue of thirty-eight titles.',
    documentation: [
      '18 photographs across the festival week',
      'Catalogue of the titles displayed',
      'Organiser exhibitor confirmation available on request',
    ],
    photos: [
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/b710c5b2-06c8-4adb-adc0-da78401d6ef2_miami00.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/4912f95f-e3cc-4169-8a55-56476e52f557_Miami1.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/bd98704e-a5c9-42f3-bd2f-04232bc8fea2_Miami3.jpg',
    ],
    reportLink: '/events',
  },
  {
    id: 'london-2025',
    startDate: '2025-03-11',
    endDate: '2025-03-13',
    fair: 'London Book Fair',
    edition: '2025',
    dates: 'March 11–13, 2025',
    venue: 'Olympia London',
    city: 'London, United Kingdom',
    stand: null,
    standNote:
      'A 2025 stand number is recorded with the organiser booking rather than on this page. We will forward it if you need it for verification.',
    summary:
      'Forty-plus titles on display at Olympia, twelve panel appearances by our authors, and distribution conversations across eight markets.',
    documentation: [
      '9 photographs from the fair floor',
      'Panel and signing programme',
      'Organiser booking record available on request',
    ],
    photos: [
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/487c929c-4bb8-431f-9598-8d70c72c8559_london001.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/29523a92-4959-45d8-a7ee-c30eb3768438_london002.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/f40d04ff-2c5f-4c34-95e8-91faddf30857_london003.jpg',
    ],
    reportLink: '/events',
  },
  {
    id: 'la-times-2025',
    startDate: null,
    endDate: null,
    fair: 'Los Angeles Times Festival of Books',
    edition: '2025',
    dates: 'April 2025',
    venue: 'USC Campus',
    city: 'Los Angeles, California',
    stand: null,
    standNote:
      'Festival booth assignment from 2025 is held on file. Request it and we will send the confirmation and the photographs together.',
    summary:
      'Our second year at the festival, with a booth that drew more than three thousand visitors and authors signing throughout the weekend.',
    documentation: [
      '7 photographs from the festival weekend',
      'Author signing rota for both days',
      'Festival exhibitor listing available on request',
    ],
    photos: [
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/6a7ca315-7952-48ae-97b6-25787e3eaf21_A7408973.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/76e2f8ae-8c40-4095-a54c-c191c0816e30_A7408971.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/82e3570c-c9f9-43a5-a5ac-d927a8ff0b28_A7408528.jpg',
    ],
    reportLink: '/events',
  },
  {
    id: 'frankfurt-2024',
    startDate: '2024-10-16',
    endDate: '2024-10-20',
    fair: 'Frankfurt Book Fair',
    edition: '2024',
    dates: 'October 16–20, 2024',
    venue: 'Messe Frankfurt',
    city: 'Frankfurt, Germany',
    stand: null,
    standNote:
      'Our first Frankfurt stand. The booking record is archived; request it and we will pull the confirmation for you.',
    summary:
      'The fair where our international programme began — a first stand at Messe Frankfurt, conversations with publishers from twenty-five countries, and rights discussions on fifteen titles.',
    documentation: [
      '20 photographs from the five fair days',
      'Rights meeting log from the week',
      'Organiser booking record available on request',
    ],
    photos: [
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/41ba1f11-0cb3-4e80-975a-10ab4b2c5957_frankfurt1.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/dce82d67-249d-4649-b2e9-dc08e33ea794_frankfurt2.jpg',
      'https://storage.readdy-site.link/project_files/d4a3ff26-933b-4c2f-85e6-4a8de0cf4dd2/4e976e6d-e9eb-45fa-b4b4-6d4fb3dab788_frankfurt3.jpg',
    ],
    reportLink: '/events',
  },
];

export const participationNote = {
  title: 'What this page is not',
  paragraphs: [
    'This is not a claim about sales, rankings, or reviews. It is a record of places we physically stood, with your titles on the table, on dates that can be checked against the fairs themselves.',
    'Where we hold the paperwork behind a detail, we print it. Where we do not, we either say so or leave the row out — because a verification page that fills its own gaps with guesses is worth nothing at all.',
  ],
};